import React from 'react'
import withSlideUpModal from '../../utils/hoc/withSlideUpModalComponent'
import { SocialAccountData } from '../../types/influencer/influencerTypes'

const CampaignAccountSelectorModal: React.FC<{onAccountSelection: (account: SocialAccountData) => void, socialAccounts: SocialAccountData[]}> = ({ onAccountSelection, socialAccounts }) => {
    const [selectedSocialAccount, setSelectedSocialAccount] = React.useState<SocialAccountData | null>(null);
    return (
    <div className='campaign-apply-confirmation'>
            <div className="d-flex flex-column gap-075">
                <h4>Select Account</h4>
            </div>

            <div className="campaign-apply-ig-connect-benefit-actions">
                <div className="account-radio-tile-group flex-column mb-3">
                    {
                        socialAccounts.map((account, index) => {
                            return (
                                <div key={index} className={`account-radio-tile px-2 py-0 w-100 ${selectedSocialAccount?.social_account.uuid === account.social_account.uuid ? 'selected' : ''}`} onClick={() => setSelectedSocialAccount(account)}>
                                    <div className="h-100 d-flex flex-row align-items-center gap-2 py-2">
                                        <img src={(account.social_account?.profile_picture_url ?? '').split("=")[0]} alt="" className='rounded-sm'/>
                                        <span className='text-dark'>{account.social_account.handle}</span>
                                    </div>  
                                </div>
                            )
                        })
                    }   
                </div>
                <button onClick={() => {
                    if(selectedSocialAccount){
                        onAccountSelection(selectedSocialAccount);
                    }
                }} disabled={!selectedSocialAccount} className="new-ui-btn">Choose</button>
            </div>

        </div>
  )
}

export default withSlideUpModal(CampaignAccountSelectorModal)